// extracted by mini-css-extract-plugin
export default {"style":"CareInput_style__iTyyU"};